import axios from '../../apis/apicidtech';
import { types } from '../../types/types';
import { getToken } from '../../utils/tokencidtechapi';
import { dispatchpending, dispatchresponse, dispatchresponseerror } from '../utils/dispatches';

export const pesquisa = (filtro = {}) => {    
    return async dispatch => {

        dispatchpending(dispatch);

        try{
            const response = await axios.get('regtron/pedidos/detalhes/pesquisa',
                {
                    headers:{
                        Accept: 'application/json',
                        Authorization: `Bearer ${getToken()}`
                    },
                    params:{
                        ...filtro
                    }
                }
            );

            dispatchresponse(dispatch,response.data,types.PEDIDOS.PESQUISA);
            return response.data;
        }catch(error){
            dispatchresponseerror(dispatch,error);
        }
    }
}

export const novoatualiza = (dados = {}) => {
    return async dispatch => {

        dispatchpending(dispatch);

        try{
            const response = await axios.put('regtron/pedidos/novoatualiza',                
                {
                    ...dados
                }
                ,
                {
                    headers:{
                        Accept: 'application/json',
                        Authorization: `Bearer ${getToken()}`
                    }                    
                }                
            );

            dispatchresponse(dispatch,response.data,types.PEDIDOS.NOVOATUALIZA);
            return response.data;
        }catch(error){
            dispatchresponseerror(dispatch,error);
        }
    }
}

export const atualizastatus = (dados = {}) => {
    
    return async dispatch => {

        dispatchpending(dispatch);

        try{
            const response = await axios.put('regtron/pedidos/status/atualiza',                
                {
                    ...dados
                }
                ,
                {
                    headers:{
                        Accept: 'application/json',
                        Authorization: `Bearer ${getToken()}`
                    }                    
                }                
            );

            dispatchresponse(dispatch,response.data,types.PEDIDOS.ATUALIZASTATUS);
            return response.data;
        }catch(error){
            dispatchresponseerror(dispatch,error);
        }
    }
}


export const checkoutstripe = (dados = {}) => {
    return async dispatch => {

        dispatchpending(dispatch);

        try{
            const response = await axios.post('pagamentos/stripe/checkout',                
                {
                    ...dados
                }
                ,
                {
                    headers:{
                        Accept: 'application/json',
                        Authorization: `Bearer ${getToken()}`
                    }                    
                }                
            );

            dispatchresponse(dispatch,response.data,types.PEDIDOS.CHECKOUTSTRIPE);
            return response.data;
        }catch(error){
            dispatchresponseerror(dispatch,error);
        }
    }
}